import { render, staticRenderFns } from "./problemList.vue?vue&type=template&id=fcebfa40&scoped=true&"
import script from "./problemList.vue?vue&type=script&lang=ts&"
export * from "./problemList.vue?vue&type=script&lang=ts&"
import style0 from "./problemList.vue?vue&type=style&index=0&id=fcebfa40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcebfa40",
  null
  
)

export default component.exports